// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2eIOh","bigColWidth":"Table_bigColWidth__prPyC","biggerColWidth":"Table_biggerColWidth__XcWDd","row":"Table_row__1k8FS","col":"Table_col__1mUgJ"};